module.exports = __webpack_public_path__ + "img/icon_drop_right_wghn.b5a38894.svg";